import React from 'react';
import settings from '../../../../../settings';

function Header() {
    return (
        <>
            <div className="absolute-container">
                <img src={`${settings.assetsPath}img/icons/settings_green.png`} alt="Instellingen icoon" />
            </div>
            <h1 className="title">LEVEL SETTINGS</h1>
        </>
    );
}

export default Header;